export default {
	async navigate(path = '/') {
		try {
			return await this.$router.push({path: path});
		} catch (e) {}
	}
}